module.exports = __webpack_public_path__ + "static/img/lirunwu.22d3c699.png";